// extracted by mini-css-extract-plugin
export default {"badge":"badge--iosFZ","group-wrapper":"group-wrapper--rouLs"};